import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { LOCATION_CHANGE } from "./eventsMapper";

function RouteChangeListener() {
  const location = useLocation();
  const dispatch = useDispatch();
  const prevPath = useRef(location.pathname);

  useEffect(() => {
    if (location.pathname !== prevPath.current) {
      dispatch({
        type: LOCATION_CHANGE,
        payload: { pathname: location.pathname },
      });
      prevPath.current = location.pathname;
    }
  }, [location, dispatch]);

  return null;
}

export default RouteChangeListener;
